import AuthPage from 'app/components/pages/Auth';
import { LoginIntent } from 'app/services/oauth/constants';
import * as React from 'react';

const LoginPage = () => <AuthPage intent={LoginIntent.Login} />;

export default LoginPage;
